export const ErrorResponseMessage = {
  error: "Oops! Something went wrong. Please refresh the page.",
  timeout: "Network Connection Error. Please refresh the page.",
  serverError: "Internal Server Error. Please refresh the page.",
  authError: "Please Sign In Again.",
  noPermission: "Access is denied.",
};
